var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgClipboard = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M16.75,3.25 L18,3.25 C19.5187831,3.25 20.75,4.48121694 20.75,6 L20.75,20 C20.75,21.5187831 19.5187831,22.75 18,22.75 L6,22.75 C4.48121694,22.75 3.25,21.5187831 3.25,20 L3.25,6 C3.25,4.48121694 4.48121694,3.25 6,3.25 L7.25,3.25 L7.25,3 C7.25,2.03350169 8.03350169,1.25 9,1.25 L15,1.25 C15.9664983,1.25 16.75,2.03350169 16.75,3 L16.75,3.25 Z M7.25,4.75 L6,4.75 C5.30964406,4.75 4.75,5.30964406 4.75,6 L4.75,20 C4.75,20.6903559 5.30964406,21.25 6,21.25 L18,21.25 C18.6903559,21.25 19.25,20.6903559 19.25,20 L19.25,6 C19.25,5.30964406 18.6903559,4.75 18,4.75 L16.75,4.75 L16.75,5 C16.75,5.96649831 15.9664983,6.75 15,6.75 L9,6.75 C8.03350169,6.75 7.25,5.96649831 7.25,5 L7.25,4.75 Z M9,2.75 C8.86192881,2.75 8.75,2.86192881 8.75,3 L8.75,5 C8.75,5.13807119 8.86192881,5.25 9,5.25 L15,5.25 C15.1380712,5.25 15.25,5.13807119 15.25,5 L15.25,3 C15.25,2.86192881 15.1380712,2.75 15,2.75 L9,2.75 Z"
  }));
};
export default SvgClipboard;